
import Loading from './index.vue'

const LoadingPlugin = {
    install(Vue: any) {
        const LoadingConstructor = Vue.extend(Loading)
        const instance = new LoadingConstructor()
        instance.$mount(document.createElement('div'))
        document.body.appendChild(instance.$el)

        Vue.prototype.$loading = {
            show: () => {
                instance.visible = true
            },
            hide: () => {
                instance.visible = false
            },
        }
    },
}

export default LoadingPlugin
